import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthenticationService } from '../services/authentication.service';

@Component({
  selector: 'pps-login',
  template: `
    <div style="padding:20px;color:#666666;font-size:18px;">
      Validating login status...
      <br/>
      <p-progressBar mode="indeterminate" [style]="{'marginTop': '10px'}"></p-progressBar>
    </div>
    
  `,
  styles: [
  ],
})
export class LoginComponent implements OnInit {
  spinnerName: string = "spinner";

  constructor(private _authService: AuthenticationService,
              private _spinner: NgxSpinnerService,
              private _router: Router) { }

  ngOnInit(): void {
    this._authService.userLoggedIn().then(loggedIn => {
      if (!loggedIn){
        this._authService.login();
      }else{
        window.setTimeout(() => this._router.navigate(["/home"], { replaceUrl: true}), 0);
      }
    });
  }
}
